// This file was generated by svgr, do not edit it.
import * as React from 'react'
import { clsx } from 'clsx'
import styles from '../Icon.module.css'
import textColorStyles from '../../../styles/atoms/text-color.module.css'
import {
  IconProps,
  computeStrokeWidth,
  computeSize,
  IconComponentRef,
} from '../helpers'
const BehanceIcon = React.forwardRef(
  (
    { size, stroke, className, color, ...props }: IconProps,
    ref: IconComponentRef,
  ) => {
    const iconName = 'behance'
    const computedSize = computeSize(size)
    const computedStrokeWidth = computeStrokeWidth(computedSize, stroke)
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={clsx(
          className,
          styles.base,
          color && textColorStyles[color],
        )}
        data-icon={iconName}
        aria-hidden="true"
        strokeWidth={computedStrokeWidth}
        width={computedSize}
        height={computedSize}
        ref={ref}
        {...props}
      >
        <path
          d="M7.39936 5C8.03324 5 8.619 5.04876 9.15664 5.19502C9.6929 5.29254 10.1343 5.49592 10.5262 5.7397C10.9194 5.98487 11.2095 6.33313 11.4075 6.78029C11.6001 7.22606 11.7046 7.77073 11.7046 8.36417C11.7046 9.05511 11.5588 9.64854 11.215 10.0943C10.9194 10.5401 10.4368 10.9385 9.84415 11.2324C10.6774 11.4776 11.3113 11.9234 11.6977 12.5168C12.0841 13.1102 12.3316 13.8499 12.3316 14.6941C12.3316 15.385 12.1872 15.9785 11.9397 16.4744C11.6928 16.9735 11.3223 17.3993 10.8644 17.71C10.4244 18.0095 9.88678 18.2533 9.30101 18.4009C8.72722 18.5545 8.13713 18.6368 7.54374 18.6461L1 18.6559V5H7.39936ZM7.00748 10.5415C7.54374 10.5415 7.98374 10.3952 8.32337 10.1445C8.66163 9.89371 8.81151 9.45212 8.81151 8.90884C8.81151 8.60795 8.76338 8.31541 8.66713 8.11899C8.56294 7.91992 8.41179 7.75004 8.22712 7.62447C8.02765 7.51428 7.81444 7.43181 7.59324 7.37929C7.35123 7.33054 7.10373 7.33054 6.8136 7.33054H3.9838V10.5484C3.9838 10.5415 7.00885 10.5415 7.00885 10.5415H7.00748ZM7.15185 16.3824C7.44748 16.3824 7.73761 16.3337 7.98512 16.2849C8.22712 16.2362 8.47463 16.1373 8.66713 15.984C8.85963 15.8308 9.01089 15.6845 9.15664 15.4408C9.25289 15.1956 9.34914 14.8961 9.34914 14.5478C9.34914 13.8569 9.15664 13.361 8.76338 13.0127C8.3715 12.7132 7.83386 12.5669 7.19998 12.5669H3.9838V16.3755H7.15323V16.3824H7.15185ZM16.5818 16.3337C16.975 16.7307 17.5594 16.9271 18.339 16.9271C18.8753 16.9271 19.3648 16.7795 19.7581 16.5287C20.1499 16.2292 20.3906 15.9353 20.4868 15.6372H22.8794C22.4861 16.8226 21.9004 17.6668 21.1221 18.2115C20.3438 18.706 19.4129 18.9999 18.2895 18.9999C17.5712 19.0032 16.8587 18.8685 16.1899 18.6029C15.5879 18.3762 15.0508 18.002 14.6265 17.5136C14.1739 17.0582 13.8378 16.4978 13.6475 15.8809C13.4068 15.2388 13.3037 14.5478 13.3037 13.7524C13.3037 13.0127 13.4 12.3148 13.6475 11.6726C13.895 11.0318 14.2332 10.4857 14.6746 9.99122C15.1146 9.54545 15.6522 9.14705 16.238 8.90187C16.8911 8.63842 17.5879 8.50367 18.2909 8.50486C19.1242 8.50486 19.8543 8.65113 20.4882 8.99939C21.1207 9.34764 21.6116 9.74048 22.0035 10.3339C22.3954 10.8772 22.6855 11.5194 22.8849 12.2117C22.9811 12.9027 23.0292 13.5992 22.9811 14.389H15.8998C15.8998 15.197 16.1885 15.9353 16.5818 16.3337ZM19.6618 11.1349C19.3181 10.7866 18.779 10.5902 18.1452 10.5902C17.7052 10.5902 17.3669 10.6877 17.0713 10.8354C16.7756 10.9817 16.5818 11.1837 16.3893 11.3787C16.2095 11.5699 16.0899 11.8108 16.0455 12.071C15.996 12.3148 15.9493 12.5168 15.9493 12.7118H20.3438C20.2476 11.9791 20.0001 11.4832 19.6604 11.1349H19.6618ZM15.3621 5.94169H20.832V7.27482H15.3621V5.94169Z"
          fill="currentColor"
        />
      </svg>
    )
  },
)
BehanceIcon.displayName = 'BehanceIcon'
export { BehanceIcon }
